import styled from 'styled-components'

import { convertHexToRGBA } from 'core/helpers'

export const Wrapper = styled.div`
  position: absolute;
  // height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: ${p => p.theme.colors.light};
  overflow: auto;
`

export const FormContainer = styled.div`
  position: relative;
  height: 70%;
  width: 100%;
  margin-top: 40px;
  margin-bottom: 5rem;
  form {
    margin-bottom: 60px;
  }
`

export const Cover = styled.div`
  padding-top: 40px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  user-select: none;
`

export const AvatarPreview = styled.div`
  position: relative;
  height: 120px;
  width: 120px;
`

export const Avatar = styled.div`
  font-family: ${p => p.theme.fonts.primary};
  position: relative;
  height: 100%;
  width: 100%;
  border-radius: 50%;
  box-shadow: 0 11px 15px -5px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: ${p => p.theme.colors.dark}!important;
  font-weight: bolder;
  font-size: 3.8rem;

  img {
    position: relative;
    width: 100%;
    border-radius: 50%;
  }
`

export const Main = styled.main`
  flex: 1 0 auto;
`

export const AvatarChange = styled.div`
  position: absolute;
  width: 30px;
  height: 30px;
  background: ${p => p.theme.colors.light};
  border-radius: 50%;
  top: auto;
  left: auto;
  bottom: 0;
  right: 10px;
  z-index: 100;
  box-shadow: 0 11px 15px -1px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;

  input {
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
  }
`

export const Username = styled.h3`
  font-family: ${p => p.theme.fonts.primary};
  position: relative;
  font-size: 1.5rem;
  margin-top: 15px;
  color: ${p => p.theme.colors.dark};
  font-weight: 650;
`

export const BtnBack = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const BtnEditPassword = styled.a`
  font-family: ${p => p.theme.fonts.secondary};
  position: relative;
  font-size: 0.8rem;
  margin-top: 0;
  font-weight: bolder;
  color: ${p => p.theme.colors.dark};
  text-align: center;
  user-select: none;
  text-decoration: underline;
`

export const BtnLogout = styled.div`
  width: 200px;
  position: relative;
  margin: 20px auto;
  padding: 10px 0px;
  background: ${p =>
    convertHexToRGBA({ hex: p.theme.colors.danger, opacity: 2 })};
  color: ${p => p.theme.colors.danger};
  border-radius: 4px;
  text-align: center;
  user-select: none;
  cursor: pointer;

  span {
    font-family: ${p => p.theme.fonts.secondary};
    font-size: 0.8rem;
  }
`

export const BtnSwitchOrgs = styled.div`
  width: 200px;
  padding: 10px 0px;
  position: relative;
  margin: 20px auto;
  cursor: pointer;
  border-radius: 4px;
  text-align: center;
  user-select: none;
  color: #000000;
  background: rgba(0, 0, 0, 0.1);

  span {
    font-family: ${p => p.theme.fonts.secondary};
    font-size: 0.8rem;
  }
`
